import {
    GET_PEJABAT_FUNGSIONAL,
    GET_JENJANG_PEJABAT_FUNGSIONAL,
    GET_PEGAWAI_FUNGSIONAL,
    RESET_JENJANG_PEJABAT_FUNGSIONAL,
    GET_JENJANG_PEJABAT_FUNGSIONAL_DAFTAR
} from 'shared/constants/ActionTypes';

const defaultData = {
    results: []
}

const INIT_STATE = {
    pejabatFungsional: { ...defaultData },
    jenPejabatFungsional: {
        list: null,
        pejabat: null
    },
    pegawaiFungsional: {
        list: {
            result: {
                child: []
            }
        }
    },
};

const laporanJabfungReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_PEJABAT_FUNGSIONAL: {
            return {
                ...state,
                pejabatFungsional: action.payload
            }
        }
        case GET_JENJANG_PEJABAT_FUNGSIONAL: {
            return {
                ...state,
                jenPejabatFungsional: {
                    ...state.jenPejabatFungsional,
                    list: action.payload
                }
            }
        }
        case GET_JENJANG_PEJABAT_FUNGSIONAL_DAFTAR: {
            return {
                ...state,
                jenPejabatFungsional: {
                    ...state.jenPejabatFungsional,
                    pejabat: action.payload
                }
            }
        }
        case RESET_JENJANG_PEJABAT_FUNGSIONAL: {
            return {
                ...state,
                jenPejabatFungsional: {
                    list: null,
                    pejabat: null
                }
            }
        }
        case GET_PEGAWAI_FUNGSIONAL: {
            return {
                ...state,
                pegawaiFungsional: {
                    list: action.payload
                }
            }
        }
        default:
            return state;
    }
};
export default laporanJabfungReducer;
